var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2426 12.0001L16.2929 7.05037C15.9024 6.65984 15.9024 6.02668 16.2929 5.63615C16.6834 5.24563 17.3166 5.24563 17.7071 5.63615L23.364 11.293C23.7545 11.6835 23.7545 12.3167 23.364 12.7072L17.7071 18.3641C17.3166 18.7546 16.6834 18.7546 16.2929 18.3641C15.9024 17.9736 15.9024 17.3404 16.2929 16.9499L21.2426 12.0001Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowLg);
export default __webpack_public_path__ + "static/media/right_arrow_lg.b5975c1cf1afc3a5890c5df9b8906c33.svg";
export { ForwardRef as ReactComponent };